import React from 'react';
import '../Css/Portfolio.css';
import thrivevasImage from '../Images/landing-Thrivevas.png';
import rentnestImage from '../Images/landing page rentnest.png';
import { FiExternalLink } from 'react-icons/fi';
import { FaComments, FaBuilding } from 'react-icons/fa';

export default function Portfolio() {
  const projects = [
    {
      title: "Thrivevas Customer Engagement Platform",
      description: "Enterprise customer engagement platform offering Bulk SMS, Voice, USSD, Payments, Surveys, Rewards, Contact Management, APIs, and custom web solutions for businesses.",
      image: thrivevasImage,
      liveLink: "https://staging-app.thrivevas.com/login",
      codeLink: "#",
      icon: <FaComments className="project-icon" />,
      tech: ["Vue.js", "Python", "PostgreSQL", "REST API"]
    },
    {
      title: "RentNest Property Management System",
      description: "Property management platform that enables landlords to manage properties, tenants, and rental operations efficiently with responsive interfaces and robust backend APIs.",
      image: rentnestImage,
      liveLink: "https://staging.rentnest.cc/",
      codeLink: "#",
      icon: <FaBuilding className="project-icon" />,
      tech: ["Laravel", "Vue.js", "MySQL", "REST API"]
    },
  ];

  return (
    <section id='portfolio'>
      <div className="portfolio-header">
        <h2 className='portfolioTitle'>My Projects</h2>
        <p className='portfolioDesc'>
          Here are some of my featured projects that demonstrate my full-stack development capabilities. 
          Each project solves real-world problems with clean, efficient code and thoughtful user experiences.
        </p>
      </div>
      
      <div className='portfolio-grid'>
        {projects.map((project, index) => (
          <div className='portfolio-card' key={index}>
            <div className="card-image-container">
              <img src={project.image} alt={project.title} className='card-image' />
              <div className="card-icon">{project.icon}</div>
            </div>
            
            <div className='card-content'>
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              
              <div className="tech-stack">
                {project.tech.map((tech, i) => (
                  <span key={i} className="tech-pill">{tech}</span>
                ))}
              </div>
              
              <div className="card-links">
                <a href={project.liveLink} target='_blank' rel='noopener noreferrer' className="link">
                  <FiExternalLink /> Live Demo
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}